/* eslint-disable */
import { v4 as uuidv4 } from 'uuid';
import { ChatType, FormTypeV2, FormTypeV3 } from '../types/chat.types';

export function transformChat(
  id: string,
  type: 'chat',
  user: string,
  time: string,
  msg: string,
  sources: string[] = [],
): ChatType {
  return { id, type, user, time, msg, sources };
}

// const randomUUID = uuidv4();
export const generateRandomId = () => uuidv4();

const commonFields = {
  suffix: {
    name: 'suffix',
    inputType: 'select',
    inputLabel: 'Suffix',
    required: false,
    select: {
      options: [
        { name: 'Jr', value: 'Jr' },
        { name: 'Sr', value: 'Sr' },
        { name: '2nd', value: '2nd' },
        { name: 'C3rd', value: 'C3rd' },
        { name: 'II', value: 'II' },
        { name: 'III', value: 'III' },
        { name: 'IV', value: 'IV' },
        { name: 'V', value: 'V' },
        { name: 'VI', value: 'VI' },
      ],
    },
    input: {},
  },
  firstName: {
    name: 'firstName',
    inputLabel: 'First Name',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      placeHolder: 'First Name',
      dataType: 'text',
      maxLength: 40,
    },
  },
  middleName: {
    name: 'middleName',
    inputLabel: 'Middle Name',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      placeHolder: 'Middle Name',
      dataType: 'text',
      maxLength: 40,
    },
  },
  lastName: {
    name: 'lastName',
    inputLabel: 'Business Name or Last Name',
    inputType: 'input',
    required: true,
    select: {},
    input: {
      placeHolder: 'Business Name or Last Name',
      dataType: 'text',
      maxLength: 40,
    },
  },
  phoneNumber: {
    name: 'phoneNumber',
    inputLabel: 'Phone Number',
    inputType: 'input',
    required: true,
    select: {},
    input: {
      placeHolder: 'Phone Number',
      dataType: 'number',
      maxLength: 10,
    },
  },
  email: {
    name: 'email',
    inputLabel: 'Email Address',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      dataType: 'email',
      maxLength: 50,
    },
  },
  address1: {
    name: 'address1',
    inputLabel: 'Address 1',
    inputType: 'input',
    required: true,
    select: {},
    input: {
      placeHolder: 'Address 1',
      dataType: 'text',
      maxLength: 40,
    },
  },
  address2: {
    name: 'address2',
    inputLabel: 'Address 2',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      placeHolder: 'Address 2',
      dataType: 'text',
      maxLength: 40,
    },
  },
  city: {
    name: 'city',
    inputLabel: 'City',
    inputType: 'input',
    required: true,
    select: {},
    input: {
      placeHolder: 'City',
      dataType: 'text',
      maxLength: 40,
    },
  },
  state: {
    name: 'state',
    inputLabel: 'State',
    inputType: 'select',
    required: true,
    select: {
      options: [{ name: 'test', value: 'test' }],
    },
    input: {},
  },
  zipCode: {
    name: 'zipCode',
    inputLabel: 'ZIP or Foreign Postal Code',
    inputType: 'input',
    required: true,
    select: {},
    conditionKey: 'PayerState',
    conditionValue: '',
    conditionType: 'not equal',
    input: {
      placeHolder: 'ZIP or Foreign Postal Code',
      dataType: 'number',
      maxLength: 9,
      minLength: 5,
    },
  },
  country: {
    name: 'country',
    inputLabel: 'Country',
    inputType: 'select',
    required: true,
    select: {
      options: [{ name: 'test', value: 'test' }],
    },
    input: {},
  },
  Type: {
    name: 'Type',
    inputType: 'select',
    inputLabel: 'Type',
    required: true,
    select: {
      options: [
        {
          name: 'Business',
          value: 'Business',
        },
        {
          name: 'Individual',
          value: 'Individual',
        },
      ],
    },
    input: {},
  },
  TINType: {
    name: 'TINType',
    inputLabel: 'Payer TIN Type',
    inputType: 'select',
    required: false,
    select: {
      disabled: true,
      options: [
        {
          name: 'EIN',
          value: 'EIN',
        },
        {
          name: 'SSN',
          value: 'SSN',
        },
      ],
    },
    input: {},
  },
  TIN: {
    name: 'TIN',
    inputLabel: 'Payer TIN',
    inputType: 'input',
    required: true,
    select: {},
    hide: true,
    input: {
      placeHolder: 'Payer TIN',
      dataType: 'number',
      maxLength: 9,
      minLength: 9,
    },
  },
  stateId: {
    name: 'StateID',
    inputLabel: 'State Id',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      dataType: 'number',
      maxLength: 15,
      minLength: 7,
    },
  },
  input_number_12: {
    name: '',
    inputLabel: '',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      dataType: 'number',
      maxLength: 12,
    },
  },
  input_text_2: {
    name: '',
    inputLabel: '',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      placeHolder: 'Box 6a State',
      dataType: 'text',
      maxLength: 2,
    },
  },
  input_text_40: {
    name: '',
    inputLabel: '',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      placeHolder: '',
      dataType: 'text',
      maxLength: 40,
    },
  },
  ExcludeStateFiling: {
    name: 'ExcludeStateFiling',
    inputType: 'select',
    inputLabel: 'Exclude State Filing',
    required: false,
    select: {
      options: [
        {
          name: 'True',
          value: 'True',
        },
        {
          name: 'False',
          value: 'False',
        },
      ],
    },
    input: {},
  },
  RecipientClientId: {
    name: 'RecipientClientId',
    inputLabel: 'Recipient ClientId',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      placeHolder: 'Recipient ClientId',
      dataType: 'text',
      maxLength: 40,
    },
  },
  GroupId: {
    name: 'GroupId',
    inputLabel: 'Group Id',
    inputType: 'input',
    required: false,
    select: {},
    input: {
      placeHolder: 'Group Id',
      dataType: 'text',
      maxLength: 40,
    },
  },
  SecondTIN: {
    name: 'SecondTINNotice',
    inputType: 'select',
    inputLabel: 'Second TIN',
    required: false,
    select: {
      options: [
        {
          name: 'True',
          value: 'True',
        },
        {
          name: 'False',
          value: 'False',
        },
      ],
    },
    input: {},
  },
  AccountNumber: {
    name: 'AccountNumber',
    inputLabel: 'Account number',
    inputType: 'input',
    required: false,
    select: {},
    value: '423423423423',
    input: {
      dataType: 'text',
      maxLength: 15,
      minLength: 7,
    },
  },
};

const payer: FormTypeV2 = {
  label: 'Payer',
  formName: 'payer',
  formFields: [
    commonFields.suffix,
    commonFields.firstName,
    commonFields.middleName,
    commonFields.lastName,
    commonFields.phoneNumber,
    commonFields.email,
    commonFields.address1,
    commonFields.address2,
    commonFields.city,
    commonFields.state,
    commonFields.zipCode,
    commonFields.country,
    commonFields.Type,
    commonFields.TINType,
    commonFields.TIN,
    {
      name: 'disregardedEntity',
      inputLabel: 'Disregarded Entity',
      inputType: 'input',
      required: false,
      select: {},
      input: {
        placeHolder: 'Disregarded Entity',
        dataType: 'text',
        maxLength: 40,
      },
    },
    commonFields.stateId,
  ],
};

const recipient: FormTypeV2 = {
  label: 'Recipient ',
  formName: 'Recipient',
  formFields: [
    commonFields.suffix,
    commonFields.firstName,
    commonFields.middleName,
    commonFields.lastName,
    { ...commonFields.phoneNumber, ...{ required: false } },
    commonFields.email,
    commonFields.address1,
    commonFields.address2,
    commonFields.city,
    commonFields.state,
    commonFields.zipCode,
    commonFields.country,
    commonFields.Type,
    commonFields.TINType,
    commonFields.TIN,
    {
      name: 'AccountNumber',
      inputLabel: 'Acct Number',
      inputType: 'input',
      required: false,
      select: {},
      input: {
        dataType: 'text',
        maxLength: 20,
      },
    },
    {
      name: 'attentionTo',
      inputLabel: 'Attention To',
      inputType: 'input',
      required: false,
      select: {},
      input: {
        dataType: 'text',
        maxLength: 40,
      },
    },
  ],
};

const necBox: FormTypeV2 = {
  label: ' Form 1099 Nec',
  formName: 'necBox',
  formFields: [
    {
      name: 'necOptions',
      inputType: 'select',
      inputLabel: 'Select Options',
      required: true,
      select: {
        options: [
          {
            name: 'Box 1 Non employee Compensation',
            value: 'Box 1 Non employee Compensation',
          },
          {
            name: 'Box 4 Fed Income Tax withheld',
            value: 'Box 4 Fed Income Tax withheld',
          },
        ],
      },
      input: {},
    },
    {
      name: 'necValue',
      inputLabel: 'Amount',
      inputType: 'input',
      required: false,
      select: {},
      input: {
        placeHolder: 'Amount',
        dataType: 'number',
        maxLength: 12,
      },
    },
    {
      ...commonFields.input_number_12,
      ...{
        name: 'Box5aStateTaxwithheld',
        inputLabel: 'Box 5a State Tax withheld',
      },
    },
    {
      ...commonFields.input_number_12,
      ...{
        name: 'Box5bStateTaxwithheld',
        inputLabel: 'Box 5b State Tax Withheld',
      },
    },
    {
      ...commonFields.input_text_2,
      ...{
        name: 'Box6aState',
        inputLabel: 'Box 6a State',
      },
    },
    {
      ...commonFields.input_text_40,
      ...{
        name: 'Box6aStateNo',
        inputLabel: 'Box 6a State No',
      },
    },
    {
      ...commonFields.input_text_2,
      ...{
        name: 'Box6bState',
        inputLabel: 'Box 6b State',
      },
    },
    {
      ...commonFields.input_text_40,
      ...{
        name: 'Box17bStateNo',
        inputLabel: 'Box 17b State No',
      },
    },
    {
      ...commonFields.input_number_12,
      ...{
        name: 'Box7aStateIncome',
        inputLabel: 'Box 7a State Income',
      },
    },
    {
      ...commonFields.input_number_12,
      ...{
        name: 'Box7bStateIncome',
        inputLabel: 'Box 7a State Income',
      },
    },
    {
      ...commonFields.input_text_40,
      ...{
        name: 'ClientID',
        inputLabel: 'ClientID',
      },
    },
    commonFields.ExcludeStateFiling,
    commonFields.RecipientClientId,
    commonFields.GroupId,
    commonFields.SecondTIN,
  ],
};

const miscBox: FormTypeV2 = {
  label: 'Form 1099 Misc',
  formName: 'miscBox',
  formFields: [
    {
      name: 'miscOptions',
      inputType: 'select',
      inputLabel: 'Select Options',
      required: true,
      select: {
        options: [
          { name: 'Box 1 Rents', value: 'Rents' },
          { name: 'Box 2 Royalties', value: 'Royalities' },
          { name: 'Box 3 Other Income', value: 'Box 3 Other Income' },
          {
            name: 'Box 4 Fed Income Tax withheld',
            value: 'Box 4 Fed Income Tax withheld',
          },
          {
            name: 'Box 5 Fishing Boat Proceeds',
            value: 'Box 5 Fishing Boat Proceeds',
          },
          {
            name: 'Box 6 Medical and health care payments',
            value: 'Box 6 Medical and health care payments',
          },
          {
            name: 'Box 7 Payer made direct Sales of $5000 or more',
            value: 'Box 7 Payer made direct Sales of $5000 or more',
          },
          {
            name: 'Box 8 Substitute Payments',
            value: 'Box 8 Substitute Payments',
          },
          {
            name: 'Box 9 Crop Insurance Proceeds',
            value: 'Box 9 Crop Insurance Proceeds',
          },
          {
            name: 'Box 10 Gross Proceeds Paid to an Attorney',
            value: 'Box 10 Gross Proceeds Paid to an Attorney',
          },
          {
            name: 'Box 11 Fish purchased for resale',
            value: 'Box 11 Fish purchased for resale',
          },
          {
            name: 'Box 12 Section 409A deferrals',
            value: 'Box 12 Section 409A deferrals',
          },
          {
            name: 'Box 13 FATCA filing requirement',
            value: 'Box 13 FATCA filing requirement',
          },
          {
            name: 'Box 14 Excess Golden Parachute',
            value: 'Box 14 Excess Golden Parachute',
          },
          {
            name: 'Box 15 Nonqualified Deferred Compensation',
            value: 'Box 15 Nonqualified Deferred Compensation',
          },
        ],
      },
      input: {},
    },
    {
      name: 'miscValue',
      inputLabel: 'Amount',
      inputType: 'input',
      required: false,
      select: {},
      input: {
        placeHolder: 'Amount',
        dataType: 'number',
        maxLength: 12,
      },
    },
    {
      ...commonFields.input_number_12,
      ...{
        name: 'Box16aStateTaxwithheld',
        inputLabel: 'Box 16a State Tax withheld',
      },
    },
    {
      ...commonFields.input_number_12,
      ...{
        name: 'Box16bStateTaxwithheld',
        inputLabel: 'Box 16b State Tax withheld',
      },
    },
    {
      ...commonFields.input_text_2,
      ...{ name: 'Box17aState', inputLabel: 'Box 17a State' },
    },
    {
      ...commonFields.input_text_40,
      ...{ name: 'Box17aStateNo', inputLabel: 'Box 17a State No' },
    },
    {
      ...commonFields.input_text_2,
      ...{ name: 'Box17bState', inputLabel: 'Box 17b State' },
    },
    {
      ...commonFields.input_text_40,
      ...{ name: 'Box17bStateNo', inputLabel: 'Box 17b State No' },
    },
    {
      ...commonFields.input_number_12,
      ...{ name: 'Box18aStateIncome', inputLabel: 'Box 18a State Income' },
    },
    {
      ...commonFields.input_number_12,
      ...{ name: 'Box18bStateIncome', inputLabel: 'Box 18a State Income' },
    },

    {
      ...commonFields.input_text_40,
      ...{ name: 'ClientPayerID', inputLabel: 'ClientPayerID' },
    },
    commonFields.ExcludeStateFiling,
    commonFields.RecipientClientId,
    commonFields.GroupId,
    commonFields.SecondTIN,
  ],
};

const payerV3: FormTypeV3 = {
  label: 'Payer',
  formName: 'payer',
  formSection: [
    {
      title: 'TIN Details',
      formFields: [
        { ...commonFields.Type, ...{ name: 'PayerType', style: 'w-6/12' } },
        {
          ...commonFields.TINType,
          style: 'w-5/12',
          ...{ name: 'FedaralIDType' },
          select: {
            ...commonFields.TINType.select,
            condition: {
              key: 'PayerType',
              values: [
                {
                  match: 'Business',
                  value: 'EIN',
                },
                {
                  match: 'Individual',
                  value: 'SSN',
                },
              ],
            },
          },
        },
        commonFields.TIN,
      ],
    },
    {
      title: 'Personal Details',
      formFields: [
        {
          ...commonFields.firstName,
          name: 'PayerFirstName',
          conditionKey: 'PayerType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          ...commonFields.middleName,
          name: 'PayerMiddleName',
          conditionKey: 'PayerType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          ...commonFields.lastName,
          name: 'PayerLastName',
          inputLabel: 'Last Name',
          conditionKey: 'PayerType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          ...commonFields.lastName,
          name: 'PayerLastName',
          inputLabel: 'Business Name',
          conditionKey: 'PayerType',
          conditionValue: 'Business',
          conditionType: 'equal',
        },
        {
          ...commonFields.suffix,
          name: 'PayerSuffix',
          conditionKey: 'PayerType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          name: 'DisregardedEntity',
          inputLabel: 'Disregarded Entity',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Disregarded Entity',
            dataType: 'text',
            maxLength: 40,
          },
        },

        { ...commonFields.address1, name: 'PayerAddress' },
        { ...commonFields.address2, name: 'PayerAddress2' },
        { ...commonFields.city, name: 'PayerCity' },
        { ...commonFields.state, name: 'PayerState' },
        { ...commonFields.zipCode, name: 'PayerZIP' },
        { ...commonFields.country, name: 'PayerCountry' },
        { ...commonFields.phoneNumber, name: 'PayerPhNo' },
        { ...commonFields.email, name: 'PayerEmail' },
        commonFields.stateId,
      ],
    },
  ],
};

const recipientV3: FormTypeV3 = {
  label: 'Recipient',
  formName: 'Recipient',
  formSection: [
    {
      title: 'TIN Details',
      formFields: [
        { ...commonFields.Type, name: 'PayeeFileType', style: 'w-5/12' },
        {
          ...commonFields.TINType,
          inputLabel: 'Recipient TIN Type',
          name: 'PayeeType',
          style: 'w-6/12',
          select: {
            ...commonFields.TINType.select,
            condition: {
              key: 'PayeeFileType',
              values: [
                {
                  match: 'Business',
                  value: 'EIN',
                },
                {
                  match: 'Individual',
                  value: 'SSN',
                },
              ],
            },
          },
        },
        { ...commonFields.TIN, name: 'PayeeTIN', inputLabel: 'Recipient TIN' },
      ],
    },
    {
      title: 'Personal Details',
      formFields: [
        {
          ...commonFields.firstName,
          name: 'PayeeFirstName',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          ...commonFields.middleName,
          name: 'PayeeMiddleName',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          ...commonFields.lastName,
          name: 'PayeeLastName',
          inputLabel: 'Last Name',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          ...commonFields.lastName,
          name: 'PayeeLastName',
          inputLabel: 'Business Name',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Business',
          conditionType: 'equal',
        },
        {
          ...commonFields.suffix,
          name: 'PayeeSuffix',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
        },
        {
          name: 'attentionTo',
          inputLabel: 'Recipient Attention To',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            dataType: 'text',
            maxLength: 40,
          },
        },

        { ...commonFields.address1, name: 'PayeeAddress' },
        { ...commonFields.address2, name: 'PayeeAddress2' },
        { ...commonFields.city, name: 'PayeeCity' },
        { ...commonFields.state, name: 'PayeeState' },
        {
          ...commonFields.zipCode,
          name: 'PayeeZIP',
          conditionKey: 'PayeeState',
        },
        { ...commonFields.country, name: 'PayeeCountry' },
        {
          ...commonFields.phoneNumber,
          ...{ name: 'PayeePhNo', required: false },
        },
        { ...commonFields.email, name: 'PayeeEmail' },
      ],
    },
  ],
};

const W8RecipientV3: FormTypeV3 = {
  label: 'W 8 Recipient',
  formName: 'Recipient',
  formSection: [
    {
      title: 'TIN Details',
      formFields: [
        {
          ...commonFields.Type,
          name: 'PayeeFileType',
          style: 'w-5/12',
          required: false,
        },
        {
          ...commonFields.TINType,
          inputLabel: 'Recipient TIN Type',
          name: 'PayeeType',
          style: 'w-6/12',
          select: {
            ...commonFields.TINType.select,
            condition: {
              key: 'PayeeFileType',
              values: [
                {
                  match: 'Business',
                  value: 'EIN',
                },
                {
                  match: 'Individual',
                  value: 'SSN',
                },
              ],
            },
          },
          required: false,
        },
        {
          ...commonFields.TIN,
          name: 'PayeeTIN',
          inputLabel: 'Recipient TIN',
          required: false,
        },
      ],
    },
    {
      title: 'Personal Details',
      formFields: [
        {
          ...commonFields.firstName,
          name: 'PayeeFirstName',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.middleName,
          name: 'PayeeMiddleName',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.lastName,
          name: 'PayeeLastName',
          inputLabel: 'Last Name',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.lastName,
          name: 'PayeeLastName',
          inputLabel: 'Business Name',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Business',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.suffix,
          name: 'PayeeSuffix',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          name: 'attentionTo',
          inputLabel: 'Recipient Attention To',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            dataType: 'text',
            maxLength: 40,
          },
        },

        { ...commonFields.address1, name: 'PayeeAddress', required: false },
        { ...commonFields.address2, name: 'PayeeAddress2', required: false },
        { ...commonFields.city, name: 'PayeeCity', required: false },
        { ...commonFields.state, name: 'PayeeState', required: false },
        {
          ...commonFields.zipCode,
          name: 'PayeeZIP',
          conditionKey: 'PayeeState',
          required: false,
        },
        { ...commonFields.country, name: 'PayeeCountry', required: false },
        {
          ...commonFields.phoneNumber,
          ...{ name: 'PayeePhNo', required: false },
        },
        { ...commonFields.email, name: 'PayeeEmail', required: true },
      ],
    },
  ],
};

const W9RecipientV3: FormTypeV3 = {
  label: 'W9 Recipient',
  formName: 'Recipient',
  formSection: [
    {
      title: 'TIN Details',
      formFields: [
        {
          ...commonFields.Type,
          name: 'PayeeFileType',
          style: 'w-5/12',
          required: false,
        },
        {
          ...commonFields.TINType,
          inputLabel: 'Recipient TIN Type',
          name: 'PayeeType',
          style: 'w-6/12',
          select: {
            ...commonFields.TINType.select,
            condition: {
              key: 'PayeeFileType',
              values: [
                {
                  match: 'Business',
                  value: 'EIN',
                },
                {
                  match: 'Individual',
                  value: 'SSN',
                },
              ],
            },
          },
          required: false,
        },
        {
          ...commonFields.TIN,
          name: 'PayeeTIN',
          inputLabel: 'Recipient TIN',
          required: false,
        },
      ],
    },
    {
      title: 'Personal Details',
      formFields: [
        {
          ...commonFields.firstName,
          name: 'PayeeFirstName',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.middleName,
          name: 'PayeeMiddleName',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.lastName,
          name: 'PayeeLastName',
          inputLabel: 'Last Name',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.lastName,
          name: 'PayeeLastName',
          inputLabel: 'Business Name',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Business',
          conditionType: 'equal',
          required: false,
        },
        {
          ...commonFields.suffix,
          name: 'PayeeSuffix',
          conditionKey: 'PayeeFileType',
          conditionValue: 'Individual',
          conditionType: 'equal',
          required: false,
        },
        {
          name: 'attentionTo',
          inputLabel: 'Recipient Attention To',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            dataType: 'text',
            maxLength: 40,
          },
        },

        { ...commonFields.address1, name: 'PayeeAddress', required: false },
        { ...commonFields.address2, name: 'PayeeAddress2', required: false },
        { ...commonFields.city, name: 'PayeeCity', required: false },
        { ...commonFields.state, name: 'PayeeState', required: false },
        {
          ...commonFields.zipCode,
          name: 'PayeeZIP',
          conditionKey: 'PayeeState',
          required: false,
        },
        { ...commonFields.country, name: 'PayeeCountry', required: false },
        {
          ...commonFields.phoneNumber,
          ...{ name: 'PayeePhNo', required: false },
        },
        { ...commonFields.email, name: 'PayeeEmail', required: true },
      ],
    },
  ],
};

const miscBoxV3: FormTypeV3 = {
  label: 'Form 1099 Misc',
  formName: 'miscBox',
  formSection: [
    {
      title: 'Misc Options',
      formFields: [
        {
          name: 'Rents',
          inputLabel: 'Box 1 Rents',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 1 Rents',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'Royalities',
          inputLabel: 'Box 2 Royalties',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 2 Royalties',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'OtherIncome',
          inputLabel: 'Box 3 Other Income',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 3 Other Income',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'FederalTax',
          inputLabel: 'Box 4 Fed Income Tax withheld',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 4 Fed Income Tax withheld',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'Fishing',
          inputLabel: 'Box 5 Fishing Boat Proceeds',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 5 Fishing Boat Proceeds',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'Medical',
          inputLabel: 'Box 6 Medical and health care payments',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 6 Medical and health care payments',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'PayerMadeDirectSales',
          inputType: 'select',
          inputLabel: 'Box 7 Payer made direct Sales of $5000 or more',
          required: false,
          select: {
            options: [
              {
                name: 'Yes',
                value: 'true',
              },
              {
                name: 'No',
                value: 'false',
              },
            ],
          },
          input: {},
        },
        {
          name: 'DividendsORInterest',
          inputLabel:
            'Box 8 Substitute payments in lieu of dividends or interest',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder:
              'Box 8 Substitute payments in lieu of dividends or interest',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'Crop',
          inputLabel: 'Box 9 Crop Insurance Proceeds',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 9 Crop Insurance Proceeds',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'GrossProceeds',
          inputLabel: 'Box 10 Gross Proceeds Paid to an Attorney',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 10 Gross Proceeds Paid to an Attorney',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'FishPurchaseResale',
          inputLabel: 'Box 11 Fish purchased for resale',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 11 Fish purchased for resale',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'A409Deferals',
          inputLabel: 'Box 12 Section 409A deferrals',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 12 Section 409A deferrals',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'ExcessGolden',
          inputLabel: 'Box 14 Excess Golden Parachute',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 14 Excess Golden Parachute',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'NonqualifiedDefCom',
          inputLabel: 'Box 15 Nonqualified Deferred Compensation',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 15 Nonqualified Deferred Compensation',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
      ],
    },
    {
      title: 'State Information',
      formFields: [
        // State 1 start
        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateWithHeld1',
            inputLabel: 'Box 16a State Tax withheld',
          },
        },
        {
          ...commonFields.state,
          required: false,
          name: 'PayerStateName1',
          inputLabel: 'Box 17a State Name',
        },
        {
          ...commonFields.input_text_40,
          ...{
            name: 'PayerStateId1',
            inputLabel: 'Box 17a Payer State ID 1',
          },
        },

        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateIncome1',
            inputLabel: 'Box 18a State Income 1',
          },
        }, /// map

        // State 2 start
        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateWithHeld2',
            inputLabel: 'Box 16b State Tax Withheld 2',
          },
        },
        {
          ...commonFields.state,
          required: false,
          name: 'PayerStateName2',
          inputLabel: 'Box 17b State Name 2',
        },

        {
          ...commonFields.input_text_40,
          ...{
            name: 'PayerStateId2',
            inputLabel: 'Box 17b Payer State ID 2',
          },
        },

        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateIncome2',
            inputLabel: 'Box 18a State Income 2',
          },
        },
        {
          ...commonFields.input_text_40,
          ...{
            name: 'ClientID',
            inputLabel: 'ClientID',
          },
        },
        commonFields.RecipientClientId,
        commonFields.GroupId,
        commonFields.SecondTIN,
        {
          ...commonFields.SecondTIN,
          name: 'Fatca',
          inputLabel: ' box 13 FATCA filing requirement',
        },
        commonFields.AccountNumber,
        { ...commonFields.SecondTIN, name: 'IsStateFiling' },
      ],
    },
  ],
};

const necBoxV3: FormTypeV3 = {
  label: 'Form 1099 NEC',
  formName: 'necBox',
  formSection: [
    {
      title: 'e-Filing Federal',
      formFields: [
        {
          name: 'NonEmployeeComp',
          inputLabel: 'Box 1 Non employee Compensation',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 1 Non employee Compensation',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        {
          name: 'PayerMadeDirectSales',
          inputType: 'select',
          inputLabel: 'Box 2 Payer made direct Sales of $5000 or more',
          required: false,
          select: {
            options: [
              {
                name: 'Yes',
                value: true,
              },
              {
                name: 'No',
                value: false,
              },
            ],
          },
          input: {},
        },
        {
          name: 'FederalTax',
          inputLabel: 'Box 4 Fed Income Tax withheld',
          inputType: 'input',
          required: false,
          select: {},
          input: {
            placeHolder: 'Box 4 Fed Income Tax withheld',
            dataType: 'decimal',
            maxLength: 12,
          },
        },
        ////
        // {
        //   name: 'necOptions',
        //   inputType: 'select',
        //   inputLabel: 'Select Options',
        //   style: 'w-9/12',
        //   required: true,
        //   select: {
        //     options: [
        //       {
        //         name: 'Box 1 Non employee Compensation',
        //         value: 'NonEmployeeComp',
        //       },
        //       {
        //         name: 'Box 2 Payer made direct Sales of $5000 or more',
        //         value: 'PayerMadeDirectSales',
        //       },
        //       {
        //         name: 'Box 3 Fed Income Tax withheld',
        //         value: 'FederalTax',
        //       },
        //     ],
        //   },
        //   input: {},
        // },
        // {
        //   name: 'necValue',
        //   inputLabel: 'Amount',
        //   inputType: 'input',
        //   required: true,
        //   style: 'w-1/5',
        //   select: {},
        //   conditionKey: 'necOptions',
        //   conditionValue: 'PayerMadeDirectSales',
        //   conditionType: 'not equal',
        //   input: {
        //     placeHolder: 'Amount',
        //     dataType: 'number',
        //     maxLength: 12,
        //   },
        // },
        // {
        //   name: 'necValue',
        //   inputType: 'select',
        //   inputLabel: 'Yes or No',
        //   required: true,
        //   style: 'w-1/5',
        //   conditionKey: 'necOptions',
        //   conditionValue: 'PayerMadeDirectSales',
        //   select: {
        //     options: [
        //       {
        //         name: 'Yes',
        //         value: 'Yes',
        //       },
        //       {
        //         name: 'No',
        //         value: 'No',
        //       },
        //     ],
        //   },
        //   input: {},
        // },
      ],
    },
    {
      title: 'State Information',
      formFields: [
        // State 1 start
        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateWithHeld1',
            inputLabel: 'Box 5a State Tax withheld',
          },
        },
        {
          ...commonFields.state,
          required: false,
          name: 'PayerStateName1',
          inputLabel: 'Box 6a State Name',
        },
        {
          ...commonFields.input_text_40,
          ...{
            name: 'PayerStateId1',
            inputLabel: 'Box 6a Payer State ID 1',
          },
        },

        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateIncome1',
            inputLabel: 'Box 7a State Income 1',
          },
        }, /// map

        // State 2 start
        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateWithHeld2',
            inputLabel: 'Box 5b State Tax Withheld 2',
          },
        },
        {
          ...commonFields.state,
          required: false,
          name: 'PayerStateName2',
          inputLabel: 'Box 6b State Name 2',
        },

        {
          ...commonFields.input_text_40,
          ...{
            name: 'PayerStateId2',
            inputLabel: 'Box 6b Payer State ID 2',
          },
        },

        {
          ...commonFields.input_number_12,
          ...{
            name: 'StateIncome2',
            inputLabel: 'Box 7a State Income 2',
          },
        },
        {
          ...commonFields.input_text_40,
          ...{
            name: 'ClientID',
            inputLabel: 'ClientID',
          },
        },

        commonFields.RecipientClientId,
        commonFields.GroupId,
        commonFields.SecondTIN,
        commonFields.AccountNumber,
        { ...commonFields.SecondTIN, name: 'IsStateFiling' },
      ],
    },
  ],
};

const MISC = { payerV3, recipientV3, miscBoxV3 };
const NEC = { payerV3, recipientV3, necBoxV3 };

const formV2 = { payer, recipient, miscBox, necBox };

export const globalForms = {
  MISC,
  NEC,
  formV2,
  payerV3,
  recipientV3,
  W8RecipientV3,
  W9RecipientV3,
};
